__turbopack_context__.v({
  "amt": "PayslipVerlauf-module__Yj2Icq__amt",
  "barLine": "PayslipVerlauf-module__Yj2Icq__barLine",
  "bars": "PayslipVerlauf-module__Yj2Icq__bars",
  "clearBtn": "PayslipVerlauf-module__Yj2Icq__clearBtn",
  "cta": "PayslipVerlauf-module__Yj2Icq__cta",
  "fillBrutto": "PayslipVerlauf-module__Yj2Icq__fillBrutto",
  "fillNetto": "PayslipVerlauf-module__Yj2Icq__fillNetto",
  "footerRow": "PayslipVerlauf-module__Yj2Icq__footerRow",
  "hintCaveat": "PayslipVerlauf-module__Yj2Icq__hintCaveat",
  "hintText": "PayslipVerlauf-module__Yj2Icq__hintText",
  "hintTitle": "PayslipVerlauf-module__Yj2Icq__hintTitle",
  "month": "PayslipVerlauf-module__Yj2Icq__month",
  "moreNote": "PayslipVerlauf-module__Yj2Icq__moreNote",
  "privacyNote": "PayslipVerlauf-module__Yj2Icq__privacyNote",
  "row": "PayslipVerlauf-module__Yj2Icq__row",
  "rows": "PayslipVerlauf-module__Yj2Icq__rows",
  "track": "PayslipVerlauf-module__Yj2Icq__track",
});
